import { Box, Flex, Text } from "@chakra-ui/react"
import { Target } from "lucide-react"
import type { GameStepItem } from "@zrt-ai-office/types/course"
import { GameChat } from "./game-chat"

interface GameChallengeProps {
  step: GameStepItem
  onComplete: () => void
}

export function GameChallenge({ step, onComplete }: GameChallengeProps) {
  if (!step.challengeScript) {
    return (
      <Box p="8" textAlign="center" color="gray.400">
        <Text>闯关脚本未配置</Text>
      </Box>
    )
  }

  return (
    <Box>
      {/* Objective card */}
      <Box
        bg="amber.50"
        borderWidth="1px"
        borderColor="amber.200"
        borderRadius="xl"
        p="4"
        mb="5"
      >
        <Flex align="center" gap="2" mb="1.5">
          <Box color="amber.600">
            <Target size={18} />
          </Box>
          <Text fontWeight="bold" fontSize="sm" color="amber.800">
            闯关目标
          </Text>
        </Flex>
        <Text fontSize="sm" color="amber.700" lineHeight="1.7">
          {step.challengeScript.objective}
        </Text>
      </Box>

      {/* Chat area */}
      <GameChat
        challengeScript={step.challengeScript}
        onComplete={onComplete}
      />
    </Box>
  )
}
